<nz-table
  #roomTable
  [nzBordered]="false"
  [nzFrontPagination]="false"
  [nzShowPagination]="false"
  [nzScroll]="{ x: '600px', y: '200px' }"
  [nzSize]="'small'"
  [nzData]="roomList"
  class="table-shadow"
>
  <thead>
    <tr>
      <th nzWidth="40%">Room Name</th>
      <th nzWidth="20%">Room Type</th>
      <th nzWidth="20%">Max Capacity</th>
      <th nzWidth="20%" nzAlign="center">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let room of roomList; let i = index">
      <!-- Room Name -->
      <td style="font-weight: bold">
        <span
          nz-tooltip
          [nzTooltipTitle]="room?.room_name"
          (click)="openRoomModal(room)"
          style="cursor: pointer; color: #4500a4"
        >
          {{ room?.room_name }}
        </span>
      </td>

      <td>{{ room?.room_type_name }}</td>

      <td>
        <span>{{ room?.max_capacity }}</span>
      </td>

      <td nzAlign="center">
        <button
          nz-button
          nzType="text"
          nzSize="small"
          nz-tooltip
          [nzTooltipTitle]="'Edit'"
          nzTooltipPlacement="top"
          (click)="editRoom(room)"
        >
          <nz-icon nzType="edit" nzTheme="outline" />
        </button>

        <button
          nz-button
          nzType="text"
          nzDanger
          nzSize="small"
          style="margin-left: 8px"
          nz-tooltip
          [nzTooltipTitle]="'Delete'"
          nzTooltipPlacement="top"
          [nz-popconfirm]="deleteRoomPopconfirm"
          [nzPopconfirmTitle]="''"
          [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deleteRoom(room.id)"
        >
          <nz-icon nzType="delete" nzTheme="outline" />
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>

<ng-template #deleteRoomPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this room?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
  <!-- <div class="custom-popconfirm-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
    <button nz-button nzType="default" nzSize="small" (click)="$event.stopPropagation(); deleteRoomPopconfirm.cancel()">Cancel</button>
    <button nz-button nzType="primary" nzDanger nzSize="small" (click)="$event.stopPropagation(); deleteRoomPopconfirm.confirm()">OK</button>
  </div> -->
</ng-template>
